module.exports = __webpack_public_path__ + "media/images/new/partner-logos@2x-2d6a361b13c936b377ca82d8f7c6ddef.png";